import { createFileRoute } from "@tanstack/react-router";

import { ShowcaseIndexPage } from "@/features/showcase/showcase-index-page";

/**
 * 事例紹介の一覧。アカウントを持たない人にも見せるため認証ガードは付けない。
 * 表示内容は固定データで、DB / API は参照しない（`showcase-data.ts` 参照）。
 */
export const Route = createFileRoute("/showcase/")({
  component: ShowcaseIndexPage,
});
